import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateUserMutationVariables = Types.Exact<{
  input: Types.CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreatePortalUserMutationVariables = Types.Exact<{
  input: Types.CreatePortalUserDataInput;
}>;


export type CreatePortalUserMutation = { __typename?: 'Mutation', createPortalUser: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateUserRolesMutationVariables = Types.Exact<{
  input: Types.UpdateUserRolesInput;
}>;


export type UpdateUserRolesMutation = { __typename?: 'Mutation', updateUserRoles: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AssignUserCustomerMutationVariables = Types.Exact<{
  input: Types.AssignUserCustomerInput;
}>;


export type AssignUserCustomerMutation = { __typename?: 'Mutation', assignUserCustomer: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AssignUserCustomersMutationVariables = Types.Exact<{
  input: Types.AssignUserCustomersInput;
}>;


export type AssignUserCustomersMutation = { __typename?: 'Mutation', assignUserCustomers: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AssignUserSitesMutationVariables = Types.Exact<{
  input: Types.AssignUserSitesInput;
}>;


export type AssignUserSitesMutation = { __typename?: 'Mutation', assignUserSites: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AssignUserRoutesMutationVariables = Types.Exact<{
  input: Types.AssignUserRoutesInput;
}>;


export type AssignUserRoutesMutation = { __typename?: 'Mutation', assignUserRoutes: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateUserFullNameMutationVariables = Types.Exact<{
  input: Types.UpdateUserFullNameInput;
}>;


export type UpdateUserFullNameMutation = { __typename?: 'Mutation', updateUserFullName: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LinkFusionAuthUserMutationVariables = Types.Exact<{
  input: Types.LinkFusionAuthUserInput;
}>;


export type LinkFusionAuthUserMutation = { __typename?: 'Mutation', linkFusionAuthUser: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LinkFusionAuthUserByEmailMutationVariables = Types.Exact<{
  input: Types.LinkFusionAuthUserByEmailInput;
}>;


export type LinkFusionAuthUserByEmailMutation = { __typename?: 'Mutation', linkFusionAuthUserByEmail: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UnlinkFusionAuthUserMutationVariables = Types.Exact<{
  input: Types.UnlinkFusionAuthUserInput;
}>;


export type UnlinkFusionAuthUserMutation = { __typename?: 'Mutation', unlinkFusionAuthUser: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateUserMutationVariables = Types.Exact<{
  input: Types.DeactivateUserInput;
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReactivateUserMutationVariables = Types.Exact<{
  input: Types.ReactivateUserInput;
}>;


export type ReactivateUserMutation = { __typename?: 'Mutation', reactivateUser: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteUserMutationVariables = Types.Exact<{
  input: Types.DeleteUserInput;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetMyProfileImageMutationVariables = Types.Exact<{
  input: Types.SetMyProfileImageDataInput;
}>;


export type SetMyProfileImageMutation = { __typename?: 'Mutation', setMyProfileImage: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', profileImageUrl?: string | null, id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearMyProfileImageMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ClearMyProfileImageMutation = { __typename?: 'Mutation', clearMyProfileImage: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', profileImageUrl?: string | null, id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetMyLanguagePreferenceMutationVariables = Types.Exact<{
  input: Types.SetMyLanguagePreferenceDataInput;
}>;


export type SetMyLanguagePreferenceMutation = { __typename?: 'Mutation', setMyLanguagePreference: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', languagePreference: Types.LanguagePreference } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type IgnoreMissingDataMutationVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  subjectId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type IgnoreMissingDataMutation = { __typename?: 'Mutation', ignoreMissingData: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, ignoredMissingData: Array<{ __typename?: 'IgnoredMissingData', code: string, subjectId?: string | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UnignoreMissingDataMutationVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  subjectId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type UnignoreMissingDataMutation = { __typename?: 'Mutation', unignoreMissingData: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string, ignoredMissingData: Array<{ __typename?: 'IgnoredMissingData', code: string, subjectId?: string | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetMyNotificationPreferencesMutationVariables = Types.Exact<{
  input: Types.SetMyNotificationPreferencesDataInput;
}>;


export type SetMyNotificationPreferencesMutation = { __typename?: 'Mutation', setMyNotificationPreferences: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', notificationEmailEnabled: boolean, notificationSmsEnabled: boolean, notificationPushEnabled: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, verifiedPhoneNumber?: string | null, pendingPhoneNumber?: string | null, smsCarrierBlockedAt?: Types.TDateISO | null, notificationEmailDeliveryMode: Types.NotificationDeliveryMode, notificationSmsDeliveryMode: Types.NotificationDeliveryMode, notificationKindOverrides: Array<{ __typename?: 'NotificationKindPreferenceData', kind: Types.NotificationKind, inApp: boolean, email: boolean, push: boolean, sms: boolean }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RequestMyPhoneVerificationMutationVariables = Types.Exact<{
  input: Types.RequestMyPhoneVerificationInput;
}>;


export type RequestMyPhoneVerificationMutation = { __typename?: 'Mutation', requestMyPhoneVerification: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', notificationEmailEnabled: boolean, notificationSmsEnabled: boolean, notificationPushEnabled: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, verifiedPhoneNumber?: string | null, pendingPhoneNumber?: string | null, smsCarrierBlockedAt?: Types.TDateISO | null, notificationEmailDeliveryMode: Types.NotificationDeliveryMode, notificationSmsDeliveryMode: Types.NotificationDeliveryMode, notificationKindOverrides: Array<{ __typename?: 'NotificationKindPreferenceData', kind: Types.NotificationKind, inApp: boolean, email: boolean, push: boolean, sms: boolean }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ConfirmMyPhoneVerificationMutationVariables = Types.Exact<{
  input: Types.ConfirmMyPhoneVerificationInput;
}>;


export type ConfirmMyPhoneVerificationMutation = { __typename?: 'Mutation', confirmMyPhoneVerification: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', notificationEmailEnabled: boolean, notificationSmsEnabled: boolean, notificationPushEnabled: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, verifiedPhoneNumber?: string | null, pendingPhoneNumber?: string | null, smsCarrierBlockedAt?: Types.TDateISO | null, notificationEmailDeliveryMode: Types.NotificationDeliveryMode, notificationSmsDeliveryMode: Types.NotificationDeliveryMode, notificationKindOverrides: Array<{ __typename?: 'NotificationKindPreferenceData', kind: Types.NotificationKind, inApp: boolean, email: boolean, push: boolean, sms: boolean }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RecordUserActivityMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type RecordUserActivityMutation = { __typename?: 'Mutation', recordUserActivity: boolean };

export type CreateUserInviteMutationVariables = Types.Exact<{
  input: Types.CreateUserInviteInput;
}>;


export type CreateUserInviteMutation = { __typename?: 'Mutation', createUserInvite: { __typename?: 'UserInvitePayload', userInvite?: { __typename?: 'UserInviteDocument', id: string, inviteId: string, recipientEmail: string, expiresAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ResendUserInviteMutationVariables = Types.Exact<{
  input: Types.ResendUserInviteInput;
}>;


export type ResendUserInviteMutation = { __typename?: 'Mutation', resendUserInvite: { __typename?: 'UserInvitePayload', userInvite?: { __typename?: 'UserInviteDocument', id: string, inviteId: string, recipientEmail: string, code: string, status: number, emailStatus: number, emailError: string, emailSentAt?: Types.TDateISO | null, expiresInDays: number, expiresAt: Types.TDateISO, createdAt: Types.TDateISO, resentAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ResetUserLoginMutationVariables = Types.Exact<{
  input: Types.ResetUserLoginInput;
}>;


export type ResetUserLoginMutation = { __typename?: 'Mutation', resetUserLogin: { __typename?: 'UserInvitePayload', userInvite?: { __typename?: 'UserInviteDocument', id: string, inviteId: string, recipientEmail: string, code: string, status: number, emailStatus: number, emailError: string, emailSentAt?: Types.TDateISO | null, expiresInDays: number, expiresAt: Types.TDateISO, createdAt: Types.TDateISO, resentAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteUserInviteMutationVariables = Types.Exact<{
  input: Types.DeleteUserInviteInput;
}>;


export type DeleteUserInviteMutation = { __typename?: 'Mutation', deleteUserInvite: { __typename?: 'UserInvitePayload', userInvite?: { __typename?: 'UserInviteDocument', id: string, inviteId: string, recipientEmail: string, code: string, status: number, emailStatus: number, emailError: string, emailSentAt?: Types.TDateISO | null, expiresInDays: number, expiresAt: Types.TDateISO, createdAt: Types.TDateISO, resentAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CompleteUserInviteAsSignedInUserMutationVariables = Types.Exact<{
  input: Types.CompleteUserInviteAsSignedInUserInput;
}>;


export type CompleteUserInviteAsSignedInUserMutation = { __typename?: 'Mutation', completeUserInviteAsSignedInUser: { __typename?: 'CompleteUserInviteAsSignedInUserPayload', completed: boolean, nextAction: Types.UserInviteNextAction, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateUserDocument = new TypedDocumentString(`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const CreatePortalUserDocument = new TypedDocumentString(`
    mutation CreatePortalUser($input: CreatePortalUserDataInput!) {
  createPortalUser(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const UpdateUserRolesDocument = new TypedDocumentString(`
    mutation UpdateUserRoles($input: UpdateUserRolesInput!) {
  updateUserRoles(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const AssignUserCustomerDocument = new TypedDocumentString(`
    mutation AssignUserCustomer($input: AssignUserCustomerInput!) {
  assignUserCustomer(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const AssignUserCustomersDocument = new TypedDocumentString(`
    mutation AssignUserCustomers($input: AssignUserCustomersInput!) {
  assignUserCustomers(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const AssignUserSitesDocument = new TypedDocumentString(`
    mutation AssignUserSites($input: AssignUserSitesInput!) {
  assignUserSites(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const AssignUserRoutesDocument = new TypedDocumentString(`
    mutation AssignUserRoutes($input: AssignUserRoutesInput!) {
  assignUserRoutes(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const UpdateUserFullNameDocument = new TypedDocumentString(`
    mutation UpdateUserFullName($input: UpdateUserFullNameInput!) {
  updateUserFullName(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const LinkFusionAuthUserDocument = new TypedDocumentString(`
    mutation LinkFusionAuthUser($input: LinkFusionAuthUserInput!) {
  linkFusionAuthUser(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const LinkFusionAuthUserByEmailDocument = new TypedDocumentString(`
    mutation LinkFusionAuthUserByEmail($input: LinkFusionAuthUserByEmailInput!) {
  linkFusionAuthUserByEmail(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const UnlinkFusionAuthUserDocument = new TypedDocumentString(`
    mutation UnlinkFusionAuthUser($input: UnlinkFusionAuthUserInput!) {
  unlinkFusionAuthUser(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const DeactivateUserDocument = new TypedDocumentString(`
    mutation DeactivateUser($input: DeactivateUserInput!) {
  deactivateUser(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const ReactivateUserDocument = new TypedDocumentString(`
    mutation ReactivateUser($input: ReactivateUserInput!) {
  reactivateUser(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const DeleteUserDocument = new TypedDocumentString(`
    mutation DeleteUser($input: DeleteUserInput!) {
  deleteUser(input: $input) {
    user {
      ...UserAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const SetMyProfileImageDocument = new TypedDocumentString(`
    mutation SetMyProfileImage($input: SetMyProfileImageDataInput!) {
  setMyProfileImage(input: $input) {
    user {
      ...UserAdmin
      profileImageUrl
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const ClearMyProfileImageDocument = new TypedDocumentString(`
    mutation ClearMyProfileImage {
  clearMyProfileImage {
    user {
      ...UserAdmin
      profileImageUrl
    }
    errors {
      code
      message
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const SetMyLanguagePreferenceDocument = new TypedDocumentString(`
    mutation SetMyLanguagePreference($input: SetMyLanguagePreferenceDataInput!) {
  setMyLanguagePreference(input: $input) {
    user {
      ...UserLanguagePreference
    }
    errors {
      code
      message
    }
  }
}
    fragment UserLanguagePreference on UserDocument {
  languagePreference
}`);
export const IgnoreMissingDataDocument = new TypedDocumentString(`
    mutation IgnoreMissingData($code: String!, $subjectId: ID) {
  ignoreMissingData(code: $code, subjectId: $subjectId) {
    user {
      ...UserIgnoredMissingData
    }
    errors {
      code
      message
    }
  }
}
    fragment UserIgnoredMissingData on UserDocument {
  id
  ignoredMissingData {
    code
    subjectId
  }
}`);
export const UnignoreMissingDataDocument = new TypedDocumentString(`
    mutation UnignoreMissingData($code: String!, $subjectId: ID) {
  unignoreMissingData(code: $code, subjectId: $subjectId) {
    user {
      ...UserIgnoredMissingData
    }
    errors {
      code
      message
    }
  }
}
    fragment UserIgnoredMissingData on UserDocument {
  id
  ignoredMissingData {
    code
    subjectId
  }
}`);
export const SetMyNotificationPreferencesDocument = new TypedDocumentString(`
    mutation SetMyNotificationPreferences($input: SetMyNotificationPreferencesDataInput!) {
  setMyNotificationPreferences(input: $input) {
    user {
      ...NotificationPreferences
    }
    errors {
      code
      message
    }
  }
}
    fragment NotificationPreferences on UserDocument {
  notificationEmailEnabled
  notificationSmsEnabled
  notificationPushEnabled
  phoneNumber
  phoneNumberVerified
  verifiedPhoneNumber
  pendingPhoneNumber
  smsCarrierBlockedAt
  notificationEmailDeliveryMode
  notificationSmsDeliveryMode
  notificationKindOverrides {
    kind
    inApp
    email
    push
    sms
  }
}`);
export const RequestMyPhoneVerificationDocument = new TypedDocumentString(`
    mutation RequestMyPhoneVerification($input: RequestMyPhoneVerificationInput!) {
  requestMyPhoneVerification(input: $input) {
    user {
      ...NotificationPreferences
    }
    errors {
      code
      message
    }
  }
}
    fragment NotificationPreferences on UserDocument {
  notificationEmailEnabled
  notificationSmsEnabled
  notificationPushEnabled
  phoneNumber
  phoneNumberVerified
  verifiedPhoneNumber
  pendingPhoneNumber
  smsCarrierBlockedAt
  notificationEmailDeliveryMode
  notificationSmsDeliveryMode
  notificationKindOverrides {
    kind
    inApp
    email
    push
    sms
  }
}`);
export const ConfirmMyPhoneVerificationDocument = new TypedDocumentString(`
    mutation ConfirmMyPhoneVerification($input: ConfirmMyPhoneVerificationInput!) {
  confirmMyPhoneVerification(input: $input) {
    user {
      ...NotificationPreferences
    }
    errors {
      code
      message
    }
  }
}
    fragment NotificationPreferences on UserDocument {
  notificationEmailEnabled
  notificationSmsEnabled
  notificationPushEnabled
  phoneNumber
  phoneNumberVerified
  verifiedPhoneNumber
  pendingPhoneNumber
  smsCarrierBlockedAt
  notificationEmailDeliveryMode
  notificationSmsDeliveryMode
  notificationKindOverrides {
    kind
    inApp
    email
    push
    sms
  }
}`);
export const RecordUserActivityDocument = new TypedDocumentString(`
    mutation RecordUserActivity {
  recordUserActivity
}
    `);
export const CreateUserInviteDocument = new TypedDocumentString(`
    mutation CreateUserInvite($input: CreateUserInviteInput!) {
  createUserInvite(input: $input) {
    userInvite {
      id
      inviteId
      recipientEmail
      expiresAt
    }
    errors {
      code
      message
    }
  }
}
    `);
export const ResendUserInviteDocument = new TypedDocumentString(`
    mutation ResendUserInvite($input: ResendUserInviteInput!) {
  resendUserInvite(input: $input) {
    userInvite {
      ...UserInviteAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserInviteAdmin on UserInviteDocument {
  id
  inviteId
  recipientEmail
  code
  status
  emailStatus
  emailError
  emailSentAt
  expiresInDays
  expiresAt
  createdAt
  resentAt
}`);
export const ResetUserLoginDocument = new TypedDocumentString(`
    mutation ResetUserLogin($input: ResetUserLoginInput!) {
  resetUserLogin(input: $input) {
    userInvite {
      ...UserInviteAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserInviteAdmin on UserInviteDocument {
  id
  inviteId
  recipientEmail
  code
  status
  emailStatus
  emailError
  emailSentAt
  expiresInDays
  expiresAt
  createdAt
  resentAt
}`);
export const DeleteUserInviteDocument = new TypedDocumentString(`
    mutation DeleteUserInvite($input: DeleteUserInviteInput!) {
  deleteUserInvite(input: $input) {
    userInvite {
      ...UserInviteAdmin
    }
    errors {
      code
      message
    }
  }
}
    fragment UserInviteAdmin on UserInviteDocument {
  id
  inviteId
  recipientEmail
  code
  status
  emailStatus
  emailError
  emailSentAt
  expiresInDays
  expiresAt
  createdAt
  resentAt
}`);
export const CompleteUserInviteAsSignedInUserDocument = new TypedDocumentString(`
    mutation CompleteUserInviteAsSignedInUser($input: CompleteUserInviteAsSignedInUserInput!) {
  completeUserInviteAsSignedInUser(input: $input) {
    completed
    nextAction
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateUser: build.mutation<CreateUserMutation, CreateUserMutationVariables>({
      query: (variables) => ({ document: CreateUserDocument, variables })
    }),
    CreatePortalUser: build.mutation<CreatePortalUserMutation, CreatePortalUserMutationVariables>({
      query: (variables) => ({ document: CreatePortalUserDocument, variables })
    }),
    UpdateUserRoles: build.mutation<UpdateUserRolesMutation, UpdateUserRolesMutationVariables>({
      query: (variables) => ({ document: UpdateUserRolesDocument, variables })
    }),
    AssignUserCustomer: build.mutation<AssignUserCustomerMutation, AssignUserCustomerMutationVariables>({
      query: (variables) => ({ document: AssignUserCustomerDocument, variables })
    }),
    AssignUserCustomers: build.mutation<AssignUserCustomersMutation, AssignUserCustomersMutationVariables>({
      query: (variables) => ({ document: AssignUserCustomersDocument, variables })
    }),
    AssignUserSites: build.mutation<AssignUserSitesMutation, AssignUserSitesMutationVariables>({
      query: (variables) => ({ document: AssignUserSitesDocument, variables })
    }),
    AssignUserRoutes: build.mutation<AssignUserRoutesMutation, AssignUserRoutesMutationVariables>({
      query: (variables) => ({ document: AssignUserRoutesDocument, variables })
    }),
    UpdateUserFullName: build.mutation<UpdateUserFullNameMutation, UpdateUserFullNameMutationVariables>({
      query: (variables) => ({ document: UpdateUserFullNameDocument, variables })
    }),
    LinkFusionAuthUser: build.mutation<LinkFusionAuthUserMutation, LinkFusionAuthUserMutationVariables>({
      query: (variables) => ({ document: LinkFusionAuthUserDocument, variables })
    }),
    LinkFusionAuthUserByEmail: build.mutation<LinkFusionAuthUserByEmailMutation, LinkFusionAuthUserByEmailMutationVariables>({
      query: (variables) => ({ document: LinkFusionAuthUserByEmailDocument, variables })
    }),
    UnlinkFusionAuthUser: build.mutation<UnlinkFusionAuthUserMutation, UnlinkFusionAuthUserMutationVariables>({
      query: (variables) => ({ document: UnlinkFusionAuthUserDocument, variables })
    }),
    DeactivateUser: build.mutation<DeactivateUserMutation, DeactivateUserMutationVariables>({
      query: (variables) => ({ document: DeactivateUserDocument, variables })
    }),
    ReactivateUser: build.mutation<ReactivateUserMutation, ReactivateUserMutationVariables>({
      query: (variables) => ({ document: ReactivateUserDocument, variables })
    }),
    DeleteUser: build.mutation<DeleteUserMutation, DeleteUserMutationVariables>({
      query: (variables) => ({ document: DeleteUserDocument, variables })
    }),
    SetMyProfileImage: build.mutation<SetMyProfileImageMutation, SetMyProfileImageMutationVariables>({
      query: (variables) => ({ document: SetMyProfileImageDocument, variables })
    }),
    ClearMyProfileImage: build.mutation<ClearMyProfileImageMutation, ClearMyProfileImageMutationVariables | void>({
      query: (variables) => ({ document: ClearMyProfileImageDocument, variables })
    }),
    SetMyLanguagePreference: build.mutation<SetMyLanguagePreferenceMutation, SetMyLanguagePreferenceMutationVariables>({
      query: (variables) => ({ document: SetMyLanguagePreferenceDocument, variables })
    }),
    IgnoreMissingData: build.mutation<IgnoreMissingDataMutation, IgnoreMissingDataMutationVariables>({
      query: (variables) => ({ document: IgnoreMissingDataDocument, variables })
    }),
    UnignoreMissingData: build.mutation<UnignoreMissingDataMutation, UnignoreMissingDataMutationVariables>({
      query: (variables) => ({ document: UnignoreMissingDataDocument, variables })
    }),
    SetMyNotificationPreferences: build.mutation<SetMyNotificationPreferencesMutation, SetMyNotificationPreferencesMutationVariables>({
      query: (variables) => ({ document: SetMyNotificationPreferencesDocument, variables })
    }),
    RequestMyPhoneVerification: build.mutation<RequestMyPhoneVerificationMutation, RequestMyPhoneVerificationMutationVariables>({
      query: (variables) => ({ document: RequestMyPhoneVerificationDocument, variables })
    }),
    ConfirmMyPhoneVerification: build.mutation<ConfirmMyPhoneVerificationMutation, ConfirmMyPhoneVerificationMutationVariables>({
      query: (variables) => ({ document: ConfirmMyPhoneVerificationDocument, variables })
    }),
    RecordUserActivity: build.mutation<RecordUserActivityMutation, RecordUserActivityMutationVariables | void>({
      query: (variables) => ({ document: RecordUserActivityDocument, variables })
    }),
    CreateUserInvite: build.mutation<CreateUserInviteMutation, CreateUserInviteMutationVariables>({
      query: (variables) => ({ document: CreateUserInviteDocument, variables })
    }),
    ResendUserInvite: build.mutation<ResendUserInviteMutation, ResendUserInviteMutationVariables>({
      query: (variables) => ({ document: ResendUserInviteDocument, variables })
    }),
    ResetUserLogin: build.mutation<ResetUserLoginMutation, ResetUserLoginMutationVariables>({
      query: (variables) => ({ document: ResetUserLoginDocument, variables })
    }),
    DeleteUserInvite: build.mutation<DeleteUserInviteMutation, DeleteUserInviteMutationVariables>({
      query: (variables) => ({ document: DeleteUserInviteDocument, variables })
    }),
    CompleteUserInviteAsSignedInUser: build.mutation<CompleteUserInviteAsSignedInUserMutation, CompleteUserInviteAsSignedInUserMutationVariables>({
      query: (variables) => ({ document: CompleteUserInviteAsSignedInUserDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateUserMutation, useCreatePortalUserMutation, useUpdateUserRolesMutation, useAssignUserCustomerMutation, useAssignUserCustomersMutation, useAssignUserSitesMutation, useAssignUserRoutesMutation, useUpdateUserFullNameMutation, useLinkFusionAuthUserMutation, useLinkFusionAuthUserByEmailMutation, useUnlinkFusionAuthUserMutation, useDeactivateUserMutation, useReactivateUserMutation, useDeleteUserMutation, useSetMyProfileImageMutation, useClearMyProfileImageMutation, useSetMyLanguagePreferenceMutation, useIgnoreMissingDataMutation, useUnignoreMissingDataMutation, useSetMyNotificationPreferencesMutation, useRequestMyPhoneVerificationMutation, useConfirmMyPhoneVerificationMutation, useRecordUserActivityMutation, useCreateUserInviteMutation, useResendUserInviteMutation, useResetUserLoginMutation, useDeleteUserInviteMutation, useCompleteUserInviteAsSignedInUserMutation } = injectedRtkApi;
